import request from '@/utils/request'

export function ensureScriptAssetGroup(scriptId, options = {}) {
  return request({ ...options, url: `/api/volc/asset/group/script/${encodeURIComponent(scriptId)}`, method: 'post' })
}

export function listAssetGroupSummaries(options = {}) {
  return request({ ...options, url: '/api/volc/asset/group/summaries', method: 'get' })
}

export function listAssetPage(params, options = {}) {
  return request({ ...options, url: '/api/volc/asset/page', method: 'get', params })
}

/**
 * 创建素材组
 */
export function createAssetGroup(data) {
  return request({
    url: '/api/volc/asset/group/create',
    method: 'post',
    data
  })
}

/**
 * 查询素材组列表
 */
export function listAssetGroups() {
  return request({
    url: '/api/volc/asset/group/list',
    method: 'get'
  })
}

/**
 * 编辑素材组
 */
export function updateAssetGroup(id, data) {
  return request({
    url: `/api/volc/asset/group/${id}`,
    method: 'put',
    data
  })
}

/**
 * 删除素材组
 */
export function deleteAssetGroup(id) {
  return request({
    url: `/api/volc/asset/group/${id}`,
    method: 'delete'
  })
}

/**
 * 上传素材
 * @param {Object} data - { groupId, imageUrl, assetName, assetType, isRealPerson }
 */
export function uploadAsset(data, options = {}) {
  return request({
    ...options,
    url: '/api/volc/asset/upload',
    method: 'post',
    data
  })
}

/**
 * 批量上传素材（文件夹）
 */
export function batchUploadAssets(groupId, files) {
  const formData = new FormData()
  formData.append('groupId', groupId)
  for (let i = 0; i < files.length; i++) {
    formData.append('files', files[i])
  }
  return request({
    url: '/api/volc/asset/upload/batch',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 300000
  })
}

/**
 * 查询素材状态
 */
export function getAssetStatus(id) {
  return request({
    url: `/api/volc/asset/status/${id}`,
    method: 'get'
  })
}

/**
 * 查询素材列表
 */
export function listAssets(groupId) {
  return request({
    url: '/api/volc/asset/list',
    method: 'get',
    params: { groupId: groupId || undefined }
  })
}

/**
 * 编辑素材
 */
export function updateAsset(id, data) {
  return request({
    url: `/api/volc/asset/${id}`,
    method: 'put',
    data
  })
}

/**
 * 删除素材
 */
export function deleteAsset(id) {
  return request({
    url: `/api/volc/asset/${id}`,
    method: 'delete'
  })
}

/**
 * 查询所有已就绪素材
 */
export function listActiveVolcAssets(scriptId) {
  return request({
    url: '/api/volc/asset/active/list',
    method: 'get',
    params: { scriptId: scriptId || undefined }
  })
}

/** 视频 @ 列表所需的轻量素材字段。 */
export function listVolcMentionAssets(scriptId) {
  return request({
    url: '/api/volc/asset/active/mentions',
    method: 'get',
    params: { scriptId: scriptId || undefined }
  })
}
